import {
  useMagicLinkExchangeSessionIdToAuthTokenMutation as useApolloMagicLinkExchangeSessionIdToAuthTokenMutation,
  useMagicLinkExchangeRefreshTokenToAuthTokenMutation as useApolloMagicLinkExchangeRefreshTokenToAuthTokenMutation,
  useRequestMagicLinkMutation as useApolloRequestMagicLinkMutation,
  MagicLinkExchangeRefreshTokenToAuthTokenMutationOptions,
  MagicLinkExchangeSessionIdToAuthTokenMutationOptions,
  RequestMagicLinkMutationOptions,
} from '@occc/graphql';

import { useMutation } from '../utils';

export const useMagicLinkExchangeRefreshTokenToAuthTokenMutation = (
  baseOptions: MagicLinkExchangeRefreshTokenToAuthTokenMutationOptions,
) => useMutation(useApolloMagicLinkExchangeRefreshTokenToAuthTokenMutation, baseOptions);

export const useMagicLinkExchangeSessionIdToAuthTokenMutation = (
  baseOptions: MagicLinkExchangeSessionIdToAuthTokenMutationOptions,
) => useMutation(useApolloMagicLinkExchangeSessionIdToAuthTokenMutation, baseOptions);

export const useRequestMagicLinkMutation = (baseOptions?: RequestMagicLinkMutationOptions) =>
  useMutation(useApolloRequestMagicLinkMutation, baseOptions);
